import { message } from "antd";
import { call, put, takeLatest } from "redux-saga/effects";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import {
	createCategoryAsync,
	getDetailCategoryAsync,
	getListCategoryAsync,
	setDetailCategory,
	setListCategory,
	updateCategoryAsync,
} from "./category.slice";
import { CategoryDetail, CreateCategoryAsyncParams, GetDetailCategoryAsyncParams, GetListCategoryAsyncParams, UpdateCategoryAsyncParams } from "../type";
import { PayloadAction } from "@reduxjs/toolkit";

function* getListCategorySaga(action: PayloadAction<GetListCategoryAsyncParams>) {
	// yield put({ type: setLoadingPage.type, payload: true });
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<CategoryDetail[]>>(
				"dashboard/categories",
				query
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback?.();
		yield put({ type: setListCategory.type, payload: response });
	} else {
		message.error(translate(error));
	}
	// yield put({ type: setLoadingPage.type, payload: false });
}

function* watchGetListCategory() {
	yield takeLatest(getListCategoryAsync, getListCategorySaga);
}

function* getDetailCategorySaga(action: PayloadAction<GetDetailCategoryAsyncParams>) {
	// yield put({ type: setLoadingPage.type, payload: true });
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<CategoryDetail>>(
				`dashboard/categories/${id}`
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setDetailCategory.type, payload: response });
	} else {
		message.error(translate(error));
	}
	// yield put({ type: setLoadingPage.type, payload: false });
}

function* watchGetDetailCategory() {
	yield takeLatest(getDetailCategoryAsync, getDetailCategorySaga);
}

function* createCategorySaga(action: PayloadAction<CreateCategoryAsyncParams>) {
	const { data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.post("dashboard/categories", data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Create successful"));
		callback();
	} else {
		message.error(translate(error));
	}
}

function* watchCreateCategory() {
	yield takeLatest(createCategoryAsync, createCategorySaga);
}

function* updateCategorySaga(action: PayloadAction<UpdateCategoryAsyncParams>) {
	const { id, data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.patch(
				`dashboard/categories/${id}`,
				data
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		message.success(translate("Update successful"));
	} else {
		message.error(translate(error));
	}
}

function* watchUpdateCategorySaga() {
	yield takeLatest(updateCategoryAsync, updateCategorySaga);
}

const categorySaga = [
	watchGetListCategory(),
	watchGetDetailCategory(),
	watchCreateCategory(),
	watchUpdateCategorySaga(),
];

export default categorySaga;
